import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="icon-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_kolosian-labs/artifacts/nn87nvtu_social%20media.png" 
            alt="Kolosian branching icon" 
            className="branching-icon-img"
          />
        </div>
        
        <h1 className="hero-title">Kolosian</h1>
        
        <p className="hero-subtitle">
          Research on neural architectures, specialization, and stability-optimized routing systems.
        </p>
        
        <a href="#publications" className="hero-cta">
          Read our work
        </a>
      </div>
    </section>
  );
};

export default Hero;